import { STATUS_OPTIONS, TYPES_OPTIONS, WALLET_OPTIONS } from 'commons';
import { integerToCurrency } from 'helpers';
import { PixTransaction } from 'types';

interface TransactionRowsProps {
  transactions: PixTransaction[];
}

const EMPTY_VALUE = '--';
const ERROR_STATUS = ['TRANSACTION_ERROR', 'ERROR'];

const createLabelMap = (options: { value: string; label: string }[]) =>
  options.reduce<Record<string, string>>((acc, { value, label }) => {
    acc[value] = label;
    return acc;
  }, {});

const TYPE_LABEL_MAP = createLabelMap(TYPES_OPTIONS);
const STATUS_LABEL_MAP = createLabelMap(STATUS_OPTIONS);
const WALLET_LABEL_MAP = createLabelMap(WALLET_OPTIONS);

function formatDate(value?: number) {
  return value ? new Date(value).toLocaleDateString('pt-BR') : EMPTY_VALUE;
}

function getLabel(map: Record<string, string>, value?: string) {
  const label = value ? (map[value] ?? value) : EMPTY_VALUE;
  const isDangerStatus = value && ERROR_STATUS.includes(value);
  const className = isDangerStatus ? 'text-danger-500' : '';

  return <span className={className}>{label}</span>;
}

function renderCurrencyValue(value = 0) {
  const isEmptyValue = value === 0;
  const isNegative = value < 0;

  const className = `whitespace-nowrap${isNegative ? ' text-danger-500' : ''}`;

  return (
    <span className={className}>
      {isEmptyValue ? EMPTY_VALUE : integerToCurrency(value)}
    </span>
  );
}

export function TransactionRows({ transactions }: TransactionRowsProps) {
  if (!transactions.length) return null;

  return transactions.map((transaction, index) => {
    const {
      id,
      creationTime,
      code,
      type,
      source,
      target,
      grossAmount,
      feeAmount,
      netAmount,
      status,
      modifiedTime,
      information,
    } = transaction;

    return (
      <tr key={`${id}-${code}-${index}`}>
        <td>{formatDate(creationTime)}</td>
        <td>{code || EMPTY_VALUE}</td>
        <td>{id || EMPTY_VALUE}</td>
        <td className="p-4 font-bold">{getLabel(TYPE_LABEL_MAP, type)}</td>
        <td>{getLabel(WALLET_LABEL_MAP, source?.walletType)}</td>
        <td>{getLabel(WALLET_LABEL_MAP, target?.walletType)}</td>
        <td>{renderCurrencyValue(grossAmount?.value)}</td>
        <td>{renderCurrencyValue(feeAmount?.value)}</td>
        <td>{renderCurrencyValue(netAmount?.value)}</td>
        <td>{getLabel(STATUS_LABEL_MAP, status)}</td>
        <td>{formatDate(modifiedTime)}</td>
        <td>{information || EMPTY_VALUE}</td>
      </tr>
    );
  });
}
